import { render, staticRenderFns } from "./user_info.vue?vue&type=template&id=51477f24&scoped=true&"
import script from "./user_info.vue?vue&type=script&lang=js&"
export * from "./user_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51477f24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51477f24')) {
      api.createRecord('51477f24', component.options)
    } else {
      api.reload('51477f24', component.options)
    }
    module.hot.accept("./user_info.vue?vue&type=template&id=51477f24&scoped=true&", function () {
      api.rerender('51477f24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/user/profile/tabs/user_info.vue"
export default component.exports